import api from '../../sxui/api/base';
import appStore from '../store/index';

// 自定义配置方法
//  before    请求发起前
api.before = (functionName, parameter = {}) => {
};

// success   请求成功后 后台返回code==200
api.success = parameter => {
};

// fail      请求失败后 后台返回code !== 200
api.fail = (parameter, newError) => {

  // 统一提示错误信息
  try {
    if (parameter.SKIP_MESSAGE || parameter.CATCH_ERROR) {
      return;
    } else {
      appStore.commit('ajaxErrorMessage', newError);
    }
  } catch (error) {
    console.warn(error);
    console.warn('vuex-未配置ajaxErrorMessage mutations--', newError);
  }

};

export default api;
